module.exports = __webpack_public_path__ + "img/zoom.d4408ca8.svg";